import { render, staticRenderFns } from "./DataIngestionButtonComponent.vue?vue&type=template&id=f50958be&data-cy=dataIngestionComponent&"
import script from "./DataIngestionButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./DataIngestionButtonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f50958be')) {
      api.createRecord('f50958be', component.options)
    } else {
      api.reload('f50958be', component.options)
    }
    module.hot.accept("./DataIngestionButtonComponent.vue?vue&type=template&id=f50958be&data-cy=dataIngestionComponent&", function () {
      api.rerender('f50958be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataIngestionButtonComponent.vue"
export default component.exports